import { WorkspaceSchema } from "@common/schemas/workspace.schema";

export type WorkspaceListEntity = WorkspaceSchema["entities"][number];

// Resolves an entity by id from the (optionally entity-bearing) workspace list
// returned by `useWorkspacesList`. Shared by the starting-point picker and the
// copy-from-entity prefill so the flatten-and-find lookup lives in one place.
export function findEntityInWorkspaces(
    workspaces: WorkspaceSchema[] | undefined,
    entityId: number | null,
): WorkspaceListEntity | null {
    if (entityId === null) {
        return null;
    }
    for (const workspace of workspaces ?? []) {
        const found = (workspace.entities ?? []).find(
            (entity) => entity.id === entityId,
        );
        if (found) {
            return found;
        }
    }
    return null;
}
